




























import { Component, Prop, Vue } from 'vue-property-decorator'
import JsonTableItem from '@/components/ui/DynamicTechTaskCard/JsonTableItem.vue'


@Component({
    name: 'JsonTable',
    components: { JsonTableItem }
})
export default class DisplayFields extends Vue {
    @Prop({ required: true }) value!: unknown
    @Prop({ default: null }) keyPrefix!: string

    get prefix() {
        return this.keyPrefix ? `${this.keyPrefix}.` : ''
    }
}
